import { Route, Routes } from "react-router-dom";
import { Login } from "../Pages/Login";
import { Register } from "../Pages/Register";
import { Home } from "../Pages/Home";
import { Company } from "../Pages/Company";
import { Databases } from "../Pages/Datbases";
import { Users } from "../Pages/Users";
import { Licenses } from "../Pages/License";
import { EtSignUsers } from "../Pages/EtsignUser";

export const AllRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/home" element={<Home />} />
      <Route path="/database/:id" element={<Databases />} />
      <Route path="/users/:dbkey" element={<Users />} />
      <Route path="/etsignusers/:id" element={<EtSignUsers />} />
      <Route path="/licenses/:id" element={<Licenses />} />
      <Route path="/register" element={<Register />} />
      <Route path="/company/:id" element={<Company />} />
      {/* <Route path="/Api/:selected_company" element={<Api />} /> */}
    </Routes>
  );
};
